import { EligibleToEditStatuses } from '../../../../../../../enums/fulfillmentplan-order-grid-status';
import {
  useGetFulfillmentPlanIdsFromSalesOrderIdWithEligibleStatus,
  useEntitiesFulfillmentPlanProperty,
} from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useHasFulfillmentPlanRestriction } from '../../../../restrictions-context';
import { UiRestrictions } from '../../../../../../../enums/component-states';

export const useGetBulkUpdatableFulfillmentPlanIds = (salesOrderId) => {
  return useGetFulfillmentPlanIdsFromSalesOrderIdWithEligibleStatus(salesOrderId, EligibleToEditStatuses);
};

export const useIsFulfillmentPlanTaxIdentifierUpdatable = (fulfillmentPlanId) => {
  const orderGridStatus = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'orderGridStatus');

  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.RecipientTaxIndentifier);
  const isEligibleStatus = EligibleToEditStatuses.includes(orderGridStatus);
  return isEligibleStatus && !isRestricted;
};
